module.exports = __webpack_public_path__ + "static/media/mentor-matcher-in-progress-premium-no-bg.d5a13222.svg";